// extracted by mini-css-extract-plugin
export default {"fieldset":"---------packages-corgi-x-src-components-Fieldset-Fieldset-module__fieldset"};